import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import iconUser from "~/assets/inline-svg/icon_user.svg?inline";
import {className} from "~/lib/helpers/string";
import Validation from "~/lib/validation";
import {request as requestRules} from "~/modules/auth/validations";

export type EmailStepMessages = {
  title: string;
  description: string;
  success: string;
  error: string;
};

@Component
class EmailStep extends Vue {

  @Prop({type: Object, required: true}) messages: EmailStepMessages;
  @Prop({type: String, required: true}) type: string;

  protected email: string = null;
  protected isLoading: boolean = false;
  protected validation = new Validation(requestRules);
  protected validationErrors = null;
  protected emailSent: boolean = false;
  protected emailError: boolean = false
  protected isValid: boolean = false;

  @Watch("email")
  async onInputChange() {
    try {
      await this.validation.validate({ email: this.email });
      this.isValid = true;
    } catch (err) {
      this.isValid = false;
    }
  }

  async validate() {
    try {
      this.validationErrors = null;
      await this.validation.validate({email: this.email})
      return true;
    } catch (err) {
      this.validationErrors = err;
      return false;
    }
  }

  showResultMessage() {
    return this.emailSent || this.emailError;
  }

  protected async send() {
    throw new Error(`Must be implemented send()`);
  }

  protected async submit(e) {
    e.preventDefault();

    if (await this.validate()) {
      this.isLoading = true;

      try {
        await this.send();
        this.emailSent = true;
      } catch (err) {
        this.emailError = true;
      }

      this.isLoading = false;
    }
  }

  protected renderLinks() {
    return null;
  }

  render() {

    if (this.showResultMessage()) {
      return (
        <p class="instructions">
          {this.emailError ? this.messages.error : this.messages.success}
        </p>
      );
    }

    return (
      <div>

        <div class="m-b-30 instructions">
          <h2 class="subtitle">{this.messages.title}</h2>
          <p>{this.messages.description}</p>
        </div>

        <div class="field with-icon">
          <label for="email" class="label">Email</label>
          <div class="control">
            <input type="email" class="input" id="email" name="email" v-model={this.email}/>
            <span class="icon" domPropsInnerHTML={iconUser}/>
          </div>
        </div>

        {this.renderLinks()}

        <div class="field has-text-centered m-t-20">
          <button class={className("button btn--action-primary btn--large ", {isLoading: this.isLoading})}
                  onClick={this.submit}
                  disabled={!this.isValid}>
            Envoyer
          </button>
        </div>

      </div>
    );
  }

}

export {EmailStep}

// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-6b84a3cc/email-step.tsx" });